import { ImageTheme } from '@/components/Image/theme';
import { tw } from '@/utils/tw';

const Image = tw.theme({
  extend: ImageTheme,
  slots: {
    group: 'md:row-start-1 md:row-end-5',
    caption: 'hidden',
  },
});

const AffiliateItem = tw.theme({});

export default Object.assign(AffiliateItem, { Image });
